import { Injectable } from '@angular/core';
import { NetworkManager } from 'src/app/managers/network/network.manager';
import { HttpHeaders } from '@angular/common/http';
import { RequestField } from 'src/app/enums/network/request/requestField.enum';
import { CQWebappApi } from 'src/app/enums/network/request/cqwebapp/cqwebappApi.enum';

@Injectable({
  providedIn: 'root',
})
export class OrganizationRequest {
  constructor(private network: NetworkManager) {}

  get(code: string) {
    let url = this.network.CodaQApi() + CQWebappApi.ORGANIZATION_GET;

    const form = new URLSearchParams();
    form.set(RequestField.ORGANIZATION_CODE, code);

    return this.network.http().put(url, form.toString());
  }

  getHub(hub: string) {
    let url = this.network.CodaQApi() + CQWebappApi.HUB_GET;

    const form = new URLSearchParams();
    form.set(RequestField.HUB_CODE, hub);

    return this.network.http().put(url, form.toString());
  }

  /**
   *
   * @param token
   */
  list(token: string, enabled: number) {
    let url = this.network.CodaQApi() + CQWebappApi.ORGANIZATION_LIST;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();
    if (enabled) form.set(RequestField.ENABLED, enabled.toString());

    return this.network.http().put(url, form.toString(), { headers });
  }

  /**
   *
   * @param token
   */
  detail(token: string, organizationId: number) {
    let url = this.network.CodaQApi() + CQWebappApi.ORGANIZATION_DETAIL;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();
    form.set(RequestField.ORGANIZATION_ID, organizationId.toString());

    return this.network.http().put(url, form.toString(), { headers });
  }

  /**
   *
   * @param token
   * @param organizationId
   * @param data
   */
  update(token: string, organizationId: number, data: string) {
    let url = this.network.CodaQApi() + CQWebappApi.ORGANIZATION_UPDATE;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();
    form.set(RequestField.ORGANIZATION_ID, organizationId.toString());
    form.set(RequestField.DATA, data.toString());

    return this.network.http().put(url, form.toString(), { headers });
  }
}
